import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { AlertTriangle, CheckCircle2, RefreshCw } from "lucide-react";
import { http } from "@/lib/api";

const ago = (iso, t) => {
  if (!iso) return t("belum pernah");
  const m = Math.max(0, Math.round((Date.now() - new Date(iso).getTime()) / 60000));
  if (m < 1) return t("baru saja");
  if (m < 60) return t("{n} menit lalu", { n: m });
  if (m < 1440) return t("{n} jam lalu", { n: Math.round(m / 60) });
  return t("{n} hari lalu", { n: Math.round(m / 1440) });
};

export default function SyncStatusCard({ propertyId, t }) {
  const [items, setItems] = useState(null);
  useEffect(() => {
    const load = () => http.get(`/extranet/properties/${propertyId}/sync-status`).then((r) => setItems(r.data.items)).catch(() => setItems([]));
    load();
    const h = setInterval(load, 60000);
    return () => clearInterval(h);
  }, [propertyId]);
  if (!items) return null;
  const stale = (iso) => !iso || Date.now() - new Date(iso).getTime() > 30 * 60000;
  return (
    <div className="rounded-lg border border-slate-200 bg-white p-4" data-testid="sync-status-card">
      <div className="flex items-center justify-between">
        <p className="flex items-center gap-1.5 text-sm font-bold"><RefreshCw className="h-4 w-4 text-slate-500" />{t("Status sinkron channel")}</p>
        <Link to="/extranet/channel" data-testid="sync-status-link" className="text-xs font-semibold text-[#006CE4] hover:underline">{t("Channel Manager")} →</Link>
      </div>
      {!items.length && <p className="mt-2 text-sm text-slate-500" data-testid="sync-status-empty">{t("Belum ada sinkron otomatis aktif (Channex, iCal atau Bookandlink).")}</p>}
      <ul className="mt-2 grid gap-2 sm:grid-cols-3">
        {items.map((s) => {
          const bad = !s.ok || stale(s.last_at);
          return (
            <li key={s.source} data-testid={`sync-status-${s.source}`} className={`rounded-md border px-3 py-2 text-sm ${bad ? "border-red-200 bg-red-50" : "border-emerald-200 bg-emerald-50"}`}>
              <p className="flex items-center gap-1.5 font-semibold">{bad ? <AlertTriangle className="h-4 w-4 text-red-600" /> : <CheckCircle2 className="h-4 w-4 text-emerald-600" />}{s.label}</p>
              <p className="text-xs text-slate-600">{t("Terakhir ditarik:")} {ago(s.last_at, t)}</p>
              {!s.ok && <p className="mt-0.5 line-clamp-2 text-xs text-red-700" data-testid={`sync-status-error-${s.source}`}>{s.failing ? <span>{t("{n} link gagal", { n: s.failing })}</span> : null}{s.failing ? " · " : ""}{s.error}</p>}
              {s.ok && stale(s.last_at) && <p className="mt-0.5 text-xs text-red-700">{t("Belum ada tarikan berhasil dalam 30 menit terakhir")}</p>}
            </li>
          );
        })}
      </ul>
    </div>
  );
}
